import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .logo-icon': {
      width: 24,
      height: 24,
      transition: theme.transitions.create(['width', 'height'], {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut,
      }),
    },
    '& .react-badge, & .logo-text': {
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut,
      }),
    },
  },
  reactBadge: {
    backgroundColor: '#121212',
    color: '#61DAFB',
  },
}));

function Logo() {
  const classes = useStyles();

  return (
    <div className={clsx(classes.root, 'flex items-center')}>
      {/* <img className="logo-icon" src="assets/images/logos/fuse.svg" alt="logo" /> */}
      <Button>
        <Link to="/visao-geral" styles={{ textDecoration: 'none' }}>
          {process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? (
            <img width="128" src="assets/images/logos/fature_mais_negativo.png" alt="logo" />
          ) : (
            <img width="128" src="assets/images/logos/group_financeiro_negativo.png" alt="logo" />
          )}
        </Link>
      </Button>
      {/* <div className="flex items-center py-4 px-8 ">
				<Icon color="primary">notifications_none_icon </Icon>
			</div> */}
    </div>
  );
}

export default Logo;
